import { styled, Typography, Grid } from '@material-ui/core'
import { ArrowLeft } from 'shared/icons'

export const Container = styled('div')(({ theme }) => ({
  width: 'fit-content',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(2.8),
}))

export const Title = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2.1),
}))

export const Icon = styled(ArrowLeft)(({ theme }) => ({
  color: theme.palette.primary.main,
}))

export const GoBackTitle = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  lineHeight: '24px',
  fontWeight: 500,
  color: theme.palette.primary.main,
  marginLeft: theme.spacing(1.5),
}))

export const GoBackWrapper = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
})
